module.exports = __webpack_public_path__ + "static/media/unico_mat_const_novo2.c07d2fe6.png";